module.exports = __webpack_public_path__ + "assets/images/2362a4c7e48abacd54a9f7f60cdd6871.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logos/ccc-logo.png
// module id = 823
// module chunks = 0